var routes = require('../routes.json');

// Get Laravel route
//
// route('route', args)
export default function route () {
    var args = Array.prototype.slice.call(arguments);
    var name = args.shift();

    if (routes[name] === undefined) {
        console.error('Unknown route ', name);
    } else {
        let baseUrl = '/';
        if (routes[name] == '/') {
            baseUrl = '';
        }
        return baseUrl + routes[name]
            .split('/')
            .map(s => s[0] == '{' ? args.shift() : s)
            .join('/');
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/route.js